/**
=========================================================
* Soft UI Dashboard PRO React - v3.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { forwardRef } from 'react';

// Custom styles for SuiTypography
import SuiTypographyRoot from './SuiTypographyRoot';

const SuiTypography = forwardRef(
    (
        {
            color,
            fontWeight,
            textTransform,
            verticalAlign,
            textGradient,
            opacity,
            children,
            ...rest
        },
        ref,
    ) => (
        <SuiTypographyRoot
            {...rest}
            ref={ref}
            ownerState={{
                color,
                textTransform,
                verticalAlign,
                fontWeight,
                opacity,
                textGradient,
            }}
        >
            {children}
        </SuiTypographyRoot>
    ),
);

// Setting default values for the props of SuiTypography
SuiTypography.defaultProps = {
    color: 'body',
    fontWeight: false,
    textTransform: 'none',
    verticalAlign: 'unset',
    textGradient: false,
    opacity: 1,
};

export default SuiTypography;
